import {
  addToRequestReportsCb,
  addToServiceReportsCb,
  createRequestReportCb,
  createServiceReportCb,
  customersCb,
  customersRts,
  requestsReportsCb,
  requestsReportsRts,
  requestTableCb,
  serviceCb,
  serviceReportsCb,
  serviceReportsRts,
  singleRequestReportCb,
  singleRequestsReportRts,
  singleServiceReportCb,
  singleServiceReportRts,
} from './resetCallbacks'

export type ResetObjectType = {
  routes: string[] //роуты на которых нужно не сбрасывать стейт
  resetCallbacks: (() => void)[] // колбеки для сброса стейта
  conditionRoutes?: string[] // роуты уходя с которых нужно  сбрасывать стейт родительских роут
  conditionCallbacks?: (() => void)[] // колбеки очищения родительских роут
}

export const resetStoreCallbacks: Record<string, ResetObjectType> = {
  '/service-reports/create': {
    routes: ['/service-reports/create'],
    resetCallbacks: createServiceReportCb,
  },
  '/service-reports/:reportId/add': {
    routes: ['/service-reports/:reportId/add'],
    resetCallbacks: addToServiceReportsCb,
    // например если уходишь с этой роуты не на /service-reports и не на /service-reports/:reportId
    // сбрасываем стейт роуты /service-reports
    conditionRoutes: ['/service-reports', '/service-reports/:reportId'],
    conditionCallbacks: serviceReportsCb,
  },
  '/service-reports/:reportId': {
    routes: singleServiceReportRts,
    resetCallbacks: singleServiceReportCb,
    conditionRoutes: ['/service-reports', '/service-reports/:reportId/add'],
    conditionCallbacks: serviceReportsCb,
  },
  '/service': {
    routes: ['/service/:serviceRequestId', '/service'],
    resetCallbacks: serviceCb,
  },
  '/service/:serviceRequestId': {
    routes: [
      '/service',
      '/service/:serviceRequestId',
      '/service-reports/:reportId',
      '/customers/:customerId',
    ],
    resetCallbacks: [
      ...serviceCb,
      ...customersCb,
      ...serviceReportsCb,
      ...singleServiceReportCb,
    ],
  },
  '/service-reports': {
    routes: serviceReportsRts,
    resetCallbacks: serviceReportsCb,
  },
  '/reports/create': {
    routes: ['/service-reports/create'],
    resetCallbacks: createRequestReportCb,
  },
  '/reports/:reportId/add': {
    routes: ['/reports/:reportId/add'],
    resetCallbacks: addToRequestReportsCb,
    // например если уходишь с этой роуты не на /service-reports и не на /service-reports/:reportId
    // сбрасываем стейт роуты /service-reports
    conditionRoutes: ['/reports', '/reports/:reportId'],
    conditionCallbacks: requestsReportsCb,
  },
  '/reports/:reportId': {
    routes: singleRequestsReportRts,
    resetCallbacks: singleRequestReportCb,
    conditionRoutes: ['/reports', '/reports/:reportId/add'],
    conditionCallbacks: requestsReportsCb,
  },
  '/requests': {
    routes: ['/requests/:requestId'],
    resetCallbacks: requestTableCb,
  },

  '/requests/:requestId': {
    routes: [
      '/requests',
      '/requests/:requestId',
      '/reports/:reportId',
      '/customers/:customerId',
      ...customersRts,
    ],

    resetCallbacks: [
      ...requestTableCb,
      ...serviceCb,
      ...customersCb,
      ...serviceReportsCb,
      ...singleServiceReportCb,
    ],
  },
  '/reports': {
    routes: requestsReportsRts,
    resetCallbacks: requestsReportsCb,
  },
  '/customers': {
    routes: customersRts,
    resetCallbacks: customersCb,
  },
  '/customers/:customerId': {
    routes: customersRts,
    resetCallbacks: customersCb,
  },
}
